import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import VitalManualEntryLayout from "../../components/Common/VitalManualEntryLayout";
import { SingleVitalInput } from "../../components/Common/VitalInput";

export interface BreathingRateManualEntryProps {
  onBack?: () => void;
  onCancel?: () => void;
  onSave?: () => void;
}

export default function BreathingRateManualEntry({
  onBack,
  onCancel,
  onSave,
}: BreathingRateManualEntryProps = {}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [value, setValue] = useState("");

  const handleBack = onBack ?? (() => navigate(-1));
  const handleCancel = onCancel ?? (() => navigate(-1));

  const handleSave = () => {
    // TODO: Implement save functionality
    console.log("Saving breathing rate:", value);
    if (onSave) onSave();
    else navigate(-1);
  };

  return (
    <VitalManualEntryLayout
      title={t("BreathingRate.manualEntry.title")}
      onBack={handleBack}
      onCancel={handleCancel}
      onSave={handleSave}
      isSaveDisabled={!value}
      cancelText={t("BreathingRate.manualEntry.cancel")}
      saveText={t("BreathingRate.manualEntry.save")}
    >
      <SingleVitalInput
        value={value}
        onChange={setValue}
        placeholder="16"
        ariaLabel={t("BreathingRate.manualEntry.inputLabel")}
        unit={t("BreathingRate.unit")}
        max={60}
      />
    </VitalManualEntryLayout>
  );
}
